<template>
  <div class="jd-home-prd">
    <div class="jd-mod-title ta-center bg-white">藏品欣赏</div>
    <!-- <div class="jd-home-prd__tabs"></div> -->
    <k-tabs
      v-model="active"
      v-if="categoryTabs"
      class="jd-tabs"
      :sticky="false"
      :offset-top="barTop"
      @click="tabItem"
    >
      <k-tab title="全部">
        <k-row v-if="getFinishOrders && getFinishOrders.length && active === 0">
          <k-col
            v-for="item in getFinishOrders"
            :key="item.id"
            span="12"
            class="jd-home-prd-item"
          >
            <k-prd-item
              :link="`/jianding/view?orderId=${item.id}`"
              target="_blank"
              :item="item"
              :img="item.pictures | getPic | resize(480, 480)"
              :title="item.definition"
              :periods="cfgPeriods[item.periods]"
              :real="cfgIsReal[item.isReal]"
            />
          </k-col>
        </k-row>
      </k-tab>
      <template v-if="categoryTabs">
        <k-tab
          v-for="item in categoryTabs"
          :key="item.id"
          :title="item.name"
          :data-tabid="item.id"
        >
          <k-row v-if="getFinishOrders && getFinishOrders.length">
            <k-col
              v-for="itm in getFinishOrders"
              span="12"
              :key="itm.id"
              class="jd-home-prd-item"
            >
              <k-prd-item
                :link="`/jianding/view?orderId=${itm.id}`"
                target="_blank"
                :item="itm"
                :img="itm.pictures | getPic | resize(480, 480)"
                :title="itm.definition"
                :periods="cfgPeriods[itm.periods]"
                :real="cfgIsReal[itm.isReal]"
              />
            </k-col>
          </k-row>
        </k-tab>
      </template>
    </k-tabs>
    <div class="k-nodata" v-if="loading">数据加载中…</div>
    <div
      class="k-nodata"
      v-else-if="getFinishOrders && getFinishOrders.length == 0"
    >
      暂无数据！
    </div>
    <div class="k-nodata" v-else>已加载完毕</div>
  </div>
</template>

<script>
import { mapGetters, mapActions, mapState } from 'vuex'
import { inMobile, WZ } from '../../../utils/wz.v2'
export default {
  name: 'mod-prd',
  data() {
    return {
      active: this.$route.query.tab || 0,
      total: 0,
      curPage: 1,
      pageNum: 20,
      totalPage: 1,
      nextPage: 1,
      loading: false,
      finished: false,
      list: null,
      barTop: inMobile() ? 44 : 65,
    }
  },
  computed: {
    ...mapGetters('jianding', [
      'getFinishOrders',
      'CONST',
      'cfgPeriods',
      'cfgIsReal',
    ]),
    ...mapState('jianding', ['categoryTabs']),
  },
  methods: {
    ...mapActions('jianding', ['finishList']),
    tabItem(index) {
      //console.log(data)
      this.$router.push({
        path: '/',
        query: {
          tab: index,
        },
      })
    },
    async fetch(page) {
      this.loading = true
      let { pageNum, active, categoryTabs } = this
      let query = {
        pageNum: pageNum,
        page: page,
        tabid: active,
        status: '4,7', //已完成 已评价
      }
      if (active > 0) {
        query.tabid = categoryTabs ? categoryTabs[active - 1].id : 0
      }
      await this.finishList(query).then((R) => {
        this.total = R.total
        this.totalPage = R.total / this.pageNum
        this.curPage = R.page
        this.nextPage = R.page + 1
        if (R.list.length < this.pageNum) {
          this.finished = true
        }
      })
      this.loading = false
    },
    async onLoading() {
    //   console.log('load:' + this.curPage + this.finished)
      if (this.totalPage > this.curPage) {
        if (!this.loading) {
          await this.fetch(this.nextPage)
        }
      }
    },
  },
  created() {
    //this.finishList({tabid:this.active})
    WZ.onScrollDownEnd(this.onLoading)
  },
  mounted() {
    this.fetch(1)
  },
  beforeDestory() {
    WZ.offScrollDownEnd(this.onLoading)
  },
  watch: {
    active() {
      this.curPage = 1
      this.finished = false
      this.fetch(1)
    },
    // getFinishOrders(nv) {
    //   //console.log(nv)
    // },
  },
}
</script>

<style scoped></style>
